<template lang="pug">
.container
  h5(v-if="mediaTags.length === 0") {{ $t('No tags in Network. Please edit and tag some media to use tag filter.') }}
  .switch(v-if="this.$store.state.Device.device_tags.length > 0")
    el-checkbox.allAny(id="TagFilterMedia-tagAllCheckbox" v-if="mediaFilterTagsLength > 1", v-model="allChecked") {{$t("all tags required")}}&nbsp;&nbsp;
    el-button(id="TagFilterMedia-switchFilterViewButton" type='text', size='mini', @click='switchTagViewMode()', :title='$t("Switch filter view")')
      font-awesome-icon(:icon="!mediumTagDropdownViewActive ? 'caret-square-down' : 'cloud'")
    el-button(id="TagFilterMedia-resetFilterButton" type='text', size='mini', @click='clearTagFilter()', :disabled='mediaFilterTagsLength === 0', :title='$t("Reset filter")')
      font-awesome-icon(icon="times")
  .container-tags-media(v-if='!mediumTagDropdownViewActive')
    .mediaTags(v-if="mediaTags.length > 0")
      el-badge.badge-item(v-if='mediumTag.media', :value="mediumTag.media.length", v-for='mediumTag in mediaTags', :key='mediumTag.id')
        el-button(:id="'TagFilterMedia-tagButton' + mediumTag.id", size="mini", :type="getTypeForTag(mediumTag)", @click="toggleTagInFilter(mediumTag)", plain) {{ mediumTag.name }}
  .container-tags-media(v-if='mediumTagDropdownViewActive')
    el-select.media-tag-dropdown(
      v-model='selectedMediumTags',
      multiple,
      filterable,
      :placeholder='$t("Select tags to filter media")')
      el-option(v-for='tag in this.$store.state.Medium.media_tags', :id="'TagFilterMedia-tagOption' + tag.id", :key='tag.id' :label='tag.name' :value='tag.id')
</template>

<script>
import NaviButtons from './NaviButtons'
import Vue from 'vue'
export default {
  props: ['side'],
  components: {
    NaviButtons
  },
  created () {
    this.mediumTagDropdownViewActive = this.$store.state.User.user.mediumTagDropdownViewActive
  },
  watch: {
    allChecked: async function (newVal, oldVal) {
      console.log('allChecked', newVal)
      this.$store.dispatch('Medium/setTagAllAnyInFilter', [ this.side, newVal ])
    },
    selectedMediumTags: async function (newVal, oldVal) {
      this.$store.dispatch('Medium/setTagsInFilter',
        [ this.side, this.$store.state.Medium.media_tags.filter(dt => newVal.includes(dt.id)) ]
      )
    }
  },
  data () {
    return {
      errors: {
      },
      allChecked: false,
      negative: false,
      mediumTagDropdownViewActive: false,
      selectedMediumTags: []
    }
  },
  methods: {
    clearTagFilter () {
      this.$store.dispatch('Medium/clearFilter', this.side)
      this.selectedMediumTags = []
    },
    async switchTagViewMode () {
      this.mediumTagDropdownViewActive = !this.mediumTagDropdownViewActive
      if (this.mediumTagDropdownViewActive) {
        this.selectedMediumTags = this.$store.state.Medium.media_filter[this.side].mediaTags.map(dt => dt.id)
      }
      await this.setViewPreference()
    },
    async setViewPreference () {
      await Vue.axios.post('user/setViewPreference', {
        mediumTagDropdownViewActive: this.mediumTagDropdownViewActive
      })
      await this.$store.dispatch('User/getMe')
    },
    toggleTagInFilter (tag) {
      this.$store.dispatch('Medium/toggleTagInFilter', [ this.side, tag ])
    },
    getTypeForTag (tag) {
      if (!tag.id) return
      let tagIndex = this.$store.state.Medium.media_filter[this.side].mediaTags.findIndex(filterTag => filterTag.id === tag.id)
      if (tagIndex > -1) {
        return 'warning'
      } else {
        return 'info'
      }
    }
  },
  computed: {
    mediaTags () {
      return this.$store.state.Medium.media_tags
    },
    mediaFilterTagsLength () {
      if (!this.$store.state.Medium.media_filter[this.side].mediaTags) return 0
      return this.$store.state.Medium.media_filter[this.side].mediaTags.length
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container-tags-media {
  border: 0px dashed pink;
  margin-top: 5px;
  margin-left: 11px;
}
.switch {
  margin-right: 10px;
  margin-left: 20px;
  text-align:right;
}
.media-tag-dropdown {
  width: 92%;
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/TagFilterMedia.vue